<template>
  <Modal
    v-model="_value"
    width="550"
    title="批量发送快捷指令"
    @on-visible-change="visibleChange"
    >
    <div class="demo-split">
      <Split v-model="split1">
        <div slot="left" class="demo-split-pane" :style="treeStyle">
          <Select
            size="small"
            style="width: 200px; margin-right: 3px;"
            v-model="selectGroupId"
            filterable
            clearable
            remote
            :remote-method="searchGroup"
            :loading="searchGroupLoading">
            <Option v-for="(option, index) in searchGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
          </Select>
          <Button type="primary" size="small" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
          <Button type="primary" size="small" style="margin-right: 3px;" @click="onClear">清空</Button>
          <Tree size="small" ref="tree" :data="groupVehicleInfoTree" :render="renderContent"
                show-checkbox class="demo-tree-render" :load-data="onLoadChildrenGroupData"
                @on-check-change="onTreeCheckChange"></Tree>
        </div>
        <div slot="right" class="demo-split-pane" style="display: inline-grid;">
          <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
          <Button type="primary" size="small" style="margin: 3px;" @click="setupReportIntervalModal = true">汇报间隔</Button>
          <Button type="primary" size="small" style="margin: 3px;" @click="jt808SetFatigueDrivingAlarmDifferenceModal = true">疲劳驾驶预警差值</Button>
          <Button type="primary" size="small" style="margin: 3px;" @click="jt808SetOverSpeedAlarmDifferenceModal = true">超速报警预警差值</Button>
          <Button type="primary" size="small" style="margin: 3px;" @click="jt808SetMaxStopTimeModal = true">最长停车时间</Button>
          <Button type="primary" size="small" style="margin: 3px;" @click="jt808SetMinRestingTimeModal = true">最小休息时间</Button>
          <Button type="primary" size="small" style="margin: 3px;" @click="jt808SetContinueDriveLimitPerDayModal = true">当天累计驾驶时间门限</Button>
          <Button type="primary" size="small" style="margin: 3px;" @click="jt808SetContinueDriveLimitModal = true">连续驾驶时间门限</Button>
          <Button type="primary" size="small" style="margin: 3px;" @click="jt808SetOverSpeedDurationModal = true">超速持续时间</Button>
          <Button type="primary" size="small" style="margin: 3px;" @click="jt808SetMaxSpeedModal = true">最高速度</Button>
        </div>
      </Split>
      <Modal v-model="setupReportIntervalModal" width="600" title="汇报间隔">
        <Form ref="setupReportInterval" autoComplete="on" v-model="setupReportInterval"
              class="card-box login-form">
          <FormItem prop="terminalNum" label="主机号列表">
            <Input style="width: 400px;" v-model="setupReportInterval.terminalNums" placeholder="请输入主机号列表">
            </Input>
          </FormItem>
          <FormItem prop="driverCardNum">
            <label style="display: inline-block; width: 100px;">ACC开上传间隔</label>
            <InputNumber :min="0" :step="1" style="display: inline-block; width: 200px;"
                         v-model="setupReportInterval.accOn" placeholder="请输入ACC开上传间隔">
            </InputNumber>
          </FormItem>
          <FormItem prop="driverLicenseNum">
            <label style="display: inline-block; width: 100px;">ACC关上传间隔</label>
            <InputNumber :min="0" :step="1" style="display: inline-block; width: 200px;"
                         v-model="setupReportInterval.accOff" placeholder="请输入ACC关上传间隔">
            </InputNumber>
          </FormItem>
          <Button type="primary" @click="onSetupReportInterval">发送</Button>
        </Form>
      </Modal>
      <jt808-set-max-speed-modal v-model="jt808SetMaxSpeedModal" :initValue="jt808SetMaxSpeedId"></jt808-set-max-speed-modal>
      <jt808-set-over-speed-duration-modal v-model="jt808SetOverSpeedDurationModal" :initValue="jt808SetOverSpeedDurationId"></jt808-set-over-speed-duration-modal>
      <jt808-set-continue-drive-limit-modal v-model="jt808SetContinueDriveLimitModal" :initValue="jt808SetContinueDriveLimitId"></jt808-set-continue-drive-limit-modal>
      <jt808-set-continue-drive-limit-per-day-modal v-model="jt808SetContinueDriveLimitPerDayModal" :initValue="jt808SetContinueDriveLimitPerDayId"></jt808-set-continue-drive-limit-per-day-modal>
      <jt808-set-min-resting-time-modal v-model="jt808SetMinRestingTimeModal" :initValue="jt808SetMinRestingTimeId"></jt808-set-min-resting-time-modal>
      <jt808-set-max-stop-time-modal v-model="jt808SetMaxStopTimeModal" :initValue="jt808SetMaxStopTimeId"></jt808-set-max-stop-time-modal>
      <jt808-set-over-speed-alarm-difference-modal v-model="jt808SetOverSpeedAlarmDifferenceModal" :initValue="jt808SetOverSpeedAlarmDifferenceId"></jt808-set-over-speed-alarm-difference-modal>
      <jt808-set-fatigue-driving-alarm-difference-modal v-model="jt808SetFatigueDrivingAlarmDifferenceModal" :initValue="jt808SetFatigueDrivingAlarmDifferenceId"></jt808-set-fatigue-driving-alarm-difference-modal>

    </div>
  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"
  import Jt808SetMaxSpeedModal from '@/view/ddm/components/jt808-set-max-speed-modal'
  import Jt808SetOverSpeedDurationModal from '@/view/ddm/components/jt808-set-over-speed-duration-modal'
  import Jt808SetContinueDriveLimitModal from '@/view/ddm/components/jt808-set-continue-drive-limit-modal'
  import Jt808SetContinueDriveLimitPerDayModal from '@/view/ddm/components/jt808-set-continue-drive-limit-per-day-modal'
  import Jt808SetMinRestingTimeModal from '@/view/ddm/components/jt808-set-min-resting-time-modal'
  import Jt808SetMaxStopTimeModal from '@/view/ddm/components/jt808-set-max-stop-time-modal'
  import Jt808SetOverSpeedAlarmDifferenceModal from '@/view/ddm/components/jt808-set-over-speed-alarm-difference-modal'
  import Jt808SetFatigueDrivingAlarmDifferenceModal from '@/view/ddm/components/jt808-set-fatigue-driving-alarm-difference-modal'

  export default {
    name: 'BatchSendcmdModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null
    },
    components: {
      Jt808SetMaxSpeedModal,
      Jt808SetOverSpeedDurationModal,
      Jt808SetContinueDriveLimitModal,
      Jt808SetContinueDriveLimitPerDayModal,
      Jt808SetMinRestingTimeModal,
      Jt808SetMaxStopTimeModal,
      Jt808SetOverSpeedAlarmDifferenceModal,
      Jt808SetFatigueDrivingAlarmDifferenceModal,

    },
    data() {
      return {
        //汇报间隔
        setupReportIntervalModal:false,
        setupReportInterval: {
          terminalNums: [],
          accOn: 15,
          accOff: 120
        },

        // 设置最高速度
        jt808SetMaxSpeedModal: false,
        jt808SetMaxSpeedId: null,

        // 设置超速持续时间
        jt808SetOverSpeedDurationModal: false,
        jt808SetOverSpeedDurationId: null,

        // 设置连续驾驶时间门限
        jt808SetContinueDriveLimitModal: false,
        jt808SetContinueDriveLimitId: null,

        // 设置当天累计驾驶时间门限
        jt808SetContinueDriveLimitPerDayModal: false,
        jt808SetContinueDriveLimitPerDayId: null,

        // 设置最小休息时间
        jt808SetMinRestingTimeModal: false,
        jt808SetMinRestingTimeId: null,

        // 设置最长停车时间
        jt808SetMaxStopTimeModal: false,
        jt808SetMaxStopTimeId: null,

        // 设置超速报警预警差值
        jt808SetOverSpeedAlarmDifferenceModal: false,
        jt808SetOverSpeedAlarmDifferenceId: null,

        // 设置疲劳驾驶预警差值
        jt808SetFatigueDrivingAlarmDifferenceModal: false,
        jt808SetFatigueDrivingAlarmDifferenceId: null,

        isSpinShow:false,

        split1:0.7,
        treeStyle: {
          'padding-left': '20px',
          'background-color': '#ffff',
          height: '100%',
          overflow: 'auto'
        },
        //分组搜索
        selectGroupId: null,
        searchGroupLoading: false,
        searchGroupList: [],

        // 树结构数据
        groupVehicleInfoTree: [{
          title: '所有车辆',
          expand: true,
          isGroup: true,
          children: [
            {
              title: '挂载车辆',
              expand: false,
              loading: false,
              isGroup: true,
              children: []
            },
            {
              title: '挂载分组',
              expand: false,
              loading: false,
              isGroup: true,
              children: []
            }
          ]
        }]
      }
    },
    methods: {
      ...mapActions([
        'InstallOrderServ_ChangeInstaller',
        'UserServ_GetAllUsers',
        'InstallOrderServ_GetDetail'
      ]),
      onSetupReportInterval () {
        console.log(this.jt808List)
        this.setupReportInterval.terminalNums = this.jt808List
        store.dispatch('NetCommandServ_BatchSetupReportInterval', {
          params: this.setupReportInterval
        }).then(() => {
          this.$Message.success('发送成功')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
        }
      },
      onClear () {
        this.selectGroupId = null
        this.groupVehicleInfoTree = null
      },
      onFilterClick () {
        console.log(this.selectGroupId)
        if (this.selectGroupId) {
          console.log('加载')
          store.dispatch('VehicleInfoGroupServ_GetDetail', {
            params: { id: this.selectGroupId },
            urlparams: null
          }).then(() => {
            let result = store.getters.get_VehicleInfoGroup_GetDetailResult ? store.getters.get_VehicleInfoGroup_GetDetailResult : []
            this.groupVehicleInfoTree = [{
              id: result.id,
              title: result.name,
              expand: false,
              isGroup: true,
              loading: false,
              children: []
            }]
            this.searchGroupLoading = false
          }).catch(err => {
            this.searchGroupLoading = false
          })
        } else {
          this.refreshRootVehicleInfoGroups()
        }
      },
      searchGroup (input) {
        this.searchGroupLoading = true
        if (!input || input.length <= 0) {
          this.searchGroupList = []
          this.searchGroupLoading = false
        } else {
          store.dispatch('VehicleInfoGroupServ_SearchByName', {
            params: { name: input },
            urlparams: null
          }).then(() => {
            this.searchGroupList = store.getters.get_VehicleInfoGroup_SearchByNameResult ? store.getters.get_VehicleInfoGroup_SearchByNameResult : []
            this.searchGroupLoading = false
          }).catch(err => {
            this.searchGroupLoading = false
          })
        }
      },
      refreshRootVehicleInfoGroups () {
          this.groupVehicleInfoTree = [{
            title: '所有车辆',
            expand: true,
            isGroup: true,
            children: [
              {
                title: '挂载车辆',
                expand: false,
                loading: false,
                isGroup: true,
                children: []
              },
              {
                title: '挂载分组',
                expand: false,
                loading: false,
                isGroup: true,
                children: []
              }
            ]
          }]
      },
      /**
       * 加载子节点回调函数
       * @param item
       * @param callback
       */
      onLoadChildrenGroupData (item, callback) {
        let tempData = []
        if (item.title === '挂载车辆') {
          store.dispatch('VehicleInfoServ_GetDirectlyUnderBindAll', {
            parmas: null,
            urlparmas: null
          }).then(() => {
            if (store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult && item.children.length == 0) {
              store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult.forEach(vehicleInfoItem => {
                if (vehicleInfoItem.positioningDeviceInfos) {
                  item.children.push(
                    {
                      id: vehicleInfoItem.id,
                      title: vehicleInfoItem.registrationNum,
                      expand: false,
                      // loading: false,
                      // children: [],
                      isGroup: false,
                      parent: item,
                      terminalNum: vehicleInfoItem.positioningDeviceInfos[0].terminalNum
                    }
                  )
                } else {
                  item.children.push(
                    {
                      id: vehicleInfoItem.id,
                      title: vehicleInfoItem.registrationNum,
                      expand: false,
                      // loading: false,
                      // children: [],
                      isGroup: false,
                      parent: item,
                      terminalNum: null
                    }
                  )
                }
              })
            }
          }).catch(err => {
            this.$Message.error(err)
            console.log(err)
          })
          callback(tempData)
        } else if (item.title === '挂载分组') {
          store.dispatch('VehicleInfoGroupServ_GetRootVehicleInfoGroups', {
            params: null,
            urlparams: null
          }).then(() => {
            if (store.getters.get_VehicleInfoGroup_GetRootVehicleInfoGroupsResult) {
              store.getters.get_VehicleInfoGroup_GetRootVehicleInfoGroupsResult.forEach(vehicleInfoGroupItem => {
                tempData.push(
                  {
                    id: vehicleInfoGroupItem.id,
                    title: vehicleInfoGroupItem.name,
                    expand: false,
                    loading: false,
                    children: [],
                    isGroup: true,
                    parent: item,
                    terminalNum: null
                  }
                )
              })
              callback(tempData)
            }
          }).catch(err => {
            this.$Message.error(err)
            console.log(err)
          })
        } else {
          // 先加载子组
          console.log('加载子组')
          store.dispatch('VehicleInfoGroupServ_GetChildrenGroups', {
            params: { id: item.id },
            urlparams: null
          }).then(() => {
            console.log(store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult)
            if (store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult.length > 0) {
              store.dispatch('VehicleInfoServ_GetByGroupId', {
                params: {
                  id: item.id
                },
                urlparmas: null
              }).then(() => {
                console.log(store.getters.get_VehicleInfo_GetByGroupIdResult)
                console.log(item)
                if (store.getters.get_VehicleInfo_GetByGroupIdResult) {
                  store.getters.get_VehicleInfo_GetByGroupIdResult.forEach(vehicleinfo => {
                    console.log(vehicleinfo.positioningDeviceInfos)
                    if (vehicleinfo.positioningDeviceInfos != null) {
                      tempData.push(
                        {
                          id: vehicleinfo.id,
                          title: vehicleinfo.registrationNum,
                          expand: false,
                          // loading: false,
                          // children: [],
                          isGroup: false,
                          parent: item,
                          terminalNum: vehicleinfo.positioningDeviceInfos[0].terminalNum
                        }
                      )
                    } else {
                      tempData.push(
                        {
                          id: vehicleinfo.id,
                          title: vehicleinfo.registrationNum,
                          expand: false,
                          // loading: false,
                          // children: [],
                          isGroup: false,
                          parent: item,
                          terminalNum: null
                        }
                      )
                    }
                  })
                }
                callback(tempData)
              }).catch(err => {
                this.$Message.error(err)
                console.log(err)
              })
              store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult.forEach(vehicleInfoGroupItem => {
                tempData.push(
                  {
                    id: vehicleInfoGroupItem.id,
                    title: vehicleInfoGroupItem.name,
                    expand: false,
                    loading: false,
                    children: [],
                    isGroup: true,
                    parent: item,
                    terminalNum: null
                  }
                )
              })
              // callback(tempData)
            } else {
              store.dispatch('VehicleInfoServ_GetByGroupId', {
                params: {
                  id: item.id
                },
                urlparmas: null
              }).then(() => {
                if (store.getters.get_VehicleInfo_GetByGroupIdResult) {
                  store.getters.get_VehicleInfo_GetByGroupIdResult.forEach(vehicleinfo => {
                    // console.log(vehicleinfo)
                    if (vehicleinfo.positioningDeviceInfos) {
                      tempData.push(
                        {
                          id: vehicleinfo.id,
                          title: vehicleinfo.registrationNum,
                          expand: false,
                          // loading: false,
                          // children: [],
                          isGroup: false,
                          parent: item,
                          terminalNum: vehicleinfo.positioningDeviceInfos[0].terminalNum
                        }
                      )
                    } else {
                      tempData.push(
                        {
                          id: vehicleinfo.id,
                          title: vehicleinfo.registrationNum,
                          expand: false,
                          // loading: false,
                          // children: [],
                          isGroup: false,
                          parent: item,
                          terminalNum: null
                        }
                      )
                    }
                  })
                }
                callback(tempData)
              }).catch(err => {
                this.$Message.error(err)
                console.log(err)
              })
            }
          }).catch(err => {
            this.$Message.error(err)
            console.log(err)
          })
        }
      },
      onTreeCheckChange (selectArray) {
        console.log(selectArray)
        this.isSpinShow = true
        this.jt808List = []
        if (selectArray.length > 0) {
          selectArray.forEach(selectArrayindex => {
            if (selectArrayindex.title === '挂载分组') {
              console.log('加载挂载分组')

              // 订阅全部分组车辆
              store.dispatch('VehicleInfoGroupServ_GetDirectlyUnderBindAll', {
                params: null,
                urlparams: null
              }).then(res => {
                // 订阅列表
                // console.log(res)
                if (store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult) {
                  store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult.forEach(vehiclegroup => {
                    store.dispatch('VehicleInfoServ_GetGroupRecursiveAll', {
                      params: {
                        groupId: vehiclegroup.id
                      },
                      urlparams: null
                    }).then(() => {
                      if (store.getters.get_VehicleInfo_GetGroupRecursiveAllResult) {
                        store.getters.get_VehicleInfo_GetGroupRecursiveAllResult.forEach(vehicle => {
                          if (vehicle.positioningDeviceInfos) {
                            // 订阅列表
                            vehicle.positioningDeviceInfos.forEach(terminalNum => {
                              this.jt808List.push(terminalNum.terminalNum)
                            })
                          }
                        })
                        this.isSpinShow = false
                      }
                    }).catch(err => {
                      console.log(err)
                    })
                  })
                }
              }).catch(err => {
                console.log(err)
              })
            } else if (selectArrayindex.title === '挂载车辆') {
              console.log('加载挂载车辆')
              store.dispatch('VehicleInfoServ_GetDirectlyUnderBindAll', {
                params: null,
                urlparams: null
              }).then(() => {
                // console.log(store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult)
                // this.vehicleDymaicManager.putVehicleInfo(store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult)
                if (store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult) {
                  store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult.forEach(vehicle => {
                    // console.log(vehicle)
                    if (vehicle.positioningDeviceInfos) {
                      // 订阅列表
                      vehicle.positioningDeviceInfos.forEach(terminalNum => {
                        this.jt808List.push(terminalNum.terminalNum)
                      })
                      this.isSpinShow = false
                    }
                  })
                }
              }).catch(err => {
                this.$Message.error(err)
                console.log(err)
              })
            } else if (selectArrayindex.title === '所有车辆') {
              console.log('加载所有车辆')

              store.dispatch('VehicleInfoServ_GetBindAll', {
                params: null,
                urlparams: null
              }).then(() => {
                // console.log(store.getters.get_VehicleInfo_GetBindAllResult)
                // this.vehicleDymaicManager.putVehicleInfo(store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult)
                if (store.getters.get_VehicleInfo_GetBindAllResult) {
                  store.getters.get_VehicleInfo_GetBindAllResult.forEach(vehicle => {
                    // console.log(vehicle)
                    if (vehicle.positioningDeviceInfos) {
                      // 订阅列表
                      vehicle.positioningDeviceInfos.forEach(terminalNum => {
                        this.jt808List.push(terminalNum.terminalNum)
                      })
                      this.isSpinShow = false
                    }
                  })
                }
              }).catch(err => {
                this.$Message.error(err)
                console.log(err)
              })
            } else {
              if (selectArrayindex.isGroup) {
                store.dispatch('VehicleInfoServ_GetGroupRecursiveAll', {
                  params: {
                    groupId: selectArrayindex.id
                  },
                  urlparams: null
                }).then(() => {
                  if (store.getters.get_VehicleInfo_GetGroupRecursiveAllResult) {
                    store.getters.get_VehicleInfo_GetGroupRecursiveAllResult.forEach(vehicle => {
                      if (vehicle.positioningDeviceInfos) {
                        // 订阅列表
                        vehicle.positioningDeviceInfos.forEach(terminalNum => {
                          this.jt808List.push(terminalNum.terminalNum)
                        })
                        this.isSpinShow = false
                      }
                    })
                  }
                }).catch(err => {
                  this.$Message.error(err)
                  console.log(err)
                })
              } else {
                store.dispatch('VehicleInfoServ_GetDetail', {
                  params: {
                    id: selectArrayindex.id
                  },
                  urlparams: null
                }).then(() => {
                  // console.log(store.getters.get_VehicleInfo_GetDetailResult)
                  if (store.getters.get_VehicleInfo_GetDetailResult) {
                    if (store.getters.get_VehicleInfo_GetDetailResult.positioningDeviceInfos) {
                      // this.jt808List.push(store.getters.get_VehicleInfo_GetDetailResult)
                      store.getters.get_VehicleInfo_GetDetailResult.positioningDeviceInfos.forEach(terminalNum => {
                        this.jt808List.push(terminalNum.terminalNum)
                      })
                      this.isSpinShow = false
                    }
                  }
                }).catch(err => {
                  console.log(err)
                })
              }
            }
          })
        }
        this.setupReportInterval.terminalNums = this.jt808List
        this.jt808SetMaxSpeedId = this.jt808List
        this.jt808SetOverSpeedDurationId = this.jt808List
        this.jt808SetContinueDriveLimitId = this.jt808List
        this.jt808SetContinueDriveLimitPerDayId = this.jt808List
        this.jt808SetMinRestingTimeId = this.jt808List
        this.jt808SetMaxStopTimeId = this.jt808List
        this.jt808SetOverSpeedAlarmDifferenceId = this.jt808List
        this.jt808SetFatigueDrivingAlarmDifferenceId = this.jt808List
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
<style scoped>
  .demo-split{
    height: 400px;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }
  .demo-split-pane.no-padding{
    height: 400px;
    padding: 0;
  }
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
